import { TOUR_TRANSLATIONS } from "../translations"

export const getSectionDetailsSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="section-details-filters"]',
            title: t.sectionDetailsFilters.title,
            content: t.sectionDetailsFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="section-details-table"]',
            title: t.sectionDetailsTable.title,
            content: t.sectionDetailsTable.content,
        },
    ]
}
